module.exports = __webpack_public_path__ + "static/media/Form_Continue_Button@2x.2a5df57e.png";